(function(){
  function init(root){
    if(root.dataset.aoReady==='1')return;root.dataset.aoReady='1';
    const controller=new AbortController();
    const listen=(target,event,handler)=>target.addEventListener(event,handler,{signal:controller.signal});
    const audio=root.querySelector('[data-ao-audio]'),tracks=[...root.querySelectorAll('[data-ao-track]')],seek=root.querySelector('[data-ao-seek]'),play=root.querySelector('[data-ao-play]'),sym=root.querySelector('[data-ao-main-symbol]'),current=root.querySelector('[data-ao-current]'),duration=root.querySelector('[data-ao-duration]'),msg=root.querySelector('[data-ao-message]'),timerText=root.querySelector('[data-ao-timer-text]');
    let selected=null,endTimer=null,timerMinutes=0,requestId=0,destroyed=false;audio.volume=.7;audio.loop=(root.dataset.defaultPlaybackMode==='loop');
    const time=n=>{if(!Number.isFinite(n))return '00:00';n=Math.floor(n);return String(Math.floor(n/60)).padStart(2,'0')+':'+String(n%60).padStart(2,'0')};
    const status=t=>{msg.textContent=t||''};
    const mainPlay = sym.querySelector('[data-ao-svg-play]');
    const mainPause = sym.querySelector('[data-ao-svg-pause]');
    const trackIcons = tracks.map(track => ({
      track,
      play: track.querySelector('[data-ao-track-play]'),
      pause: track.querySelector('[data-ao-track-pause]')
    }));
    function setIconVisible(icon, visible) {
      if (icon) icon.toggleAttribute('hidden', !visible);
    }
    const update = () => {
      const playing = !audio.paused && !audio.ended;
      setIconVisible(mainPlay, !playing);
      setIconVisible(mainPause, playing);
      play.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      play.setAttribute('aria-pressed', String(playing));
      trackIcons.forEach(icons => {
        const active = icons.track === selected && playing;
        setIconVisible(icons.play, !active);
        setIconVisible(icons.pause, active);
      });
    };
    async function start(){
      if(destroyed)return;
      if(!audio.getAttribute('src')){status('Please add an MP3 URL in the theme editor.');return}
      const request=++requestId;
      try{
        await audio.play();
        if(!destroyed&&request===requestId)status('');
      }catch(error){
        if(!destroyed&&request===requestId&&error.name!=='AbortError')
          status('Unable to play. Check the audio URL, then tap Play again.');
      }
      if(!destroyed&&request===requestId)update();
    }
    function pause(){requestId++;audio.pause();update()}
    const title=root.querySelector('[data-ao-title]');
    const description=root.querySelector('[data-ao-description]');
    const player=root.querySelector('.aoovoo-nature__player');
    function choose(track,shouldPlay){
      if(!track||destroyed)return;
      if(selected===track&&shouldPlay){audio.paused?start():pause();return}
      pause();selected=track;
      tracks.forEach(item=>item.classList.toggle('is-selected',item===track));
      title.textContent=track.dataset.title||'';
      description.textContent=track.dataset.description||'';
      if(track.dataset.scene)player.style.setProperty('--ao-scene','url('+JSON.stringify(track.dataset.scene)+')');
      seek.value=0;current.textContent='00:00';duration.textContent='00:00';
      if(track.dataset.audio){audio.src=track.dataset.audio;status('')}
      else{audio.removeAttribute('src');status('No audio URL is configured for this sound.')}
      audio.load();update();
      if(shouldPlay)start();
    }
    // Keep each sound's shareable URL in sync without reloading the Shopify page.
    function updateSoundUrl(track){
      if(!track || !track.dataset.key) return;
      const url=new URL(window.location.href);
      const key=track.dataset.key.toLowerCase();
      if(url.searchParams.get('scent')===key) return;
      url.searchParams.set('scent',key);
      window.history.pushState({aoovooScent:key},'',url.pathname+url.search+url.hash);
    }
    listen(play,'click',()=>audio.paused?start():pause());
    tracks.forEach(t=>listen(t,'click',()=>{
      updateSoundUrl(t);
      choose(t,true);
    }));
    // Restore the sound when the visitor uses the browser Back/Forward buttons.
    listen(window,'popstate',()=>{
      const key=(new URLSearchParams(window.location.search).get('scent')||root.dataset.defaultScent||'').toLowerCase();
      const match=tracks.find(t=>t.dataset.key===key)||tracks[0];
      if(match&&match!==selected)choose(match,false);
    });
    // Playback modes: the default is sequential (unless configured otherwise in the editor).
    const modeButton=root.querySelector('[data-ao-loop]');
    const modeLabel=modeButton.querySelector('span');
    const modeIcon=modeButton.querySelector('svg');
    function syncPlaybackMode(){
      modeLabel.textContent=audio.loop?'Loop':'Play in order';
      // Matching minimalist line icons: repeat arrows or playlist with a play triangle.
      modeIcon.innerHTML=audio.loop
        ? '<path d="M4 8a7 7 0 0 1 12-3l2 2"/><path d="M18 3v4h-4"/><path d="M20 16a7 7 0 0 1-12 3l-2-2"/><path d="M6 21v-4h4"/>'
        : '<path d="M3 6h12M3 12h9M3 18h9"/><path d="m16 14 5 4-5 3.5z"/>';
      modeButton.classList.toggle('is-active',audio.loop);
      modeButton.setAttribute('aria-pressed',String(audio.loop));
      modeButton.setAttribute('aria-label',audio.loop?'Loop current sound; switch to play in order':'Play in order; switch to loop current sound');
    }
    syncPlaybackMode();
    listen(audio,'ended',()=>{
      update();
      if(audio.loop||!selected||!tracks.length)return;
      const index=tracks.indexOf(selected);
      const next=tracks[(index+1)%tracks.length];
      if(next){updateSoundUrl(next);choose(next,true)}
    });
    listen(audio,'play',update);listen(audio,'pause',update);listen(audio,'loadedmetadata',()=>{duration.textContent=time(audio.duration)});listen(audio,'timeupdate',()=>{current.textContent=time(audio.currentTime);seek.value=Number.isFinite(audio.duration)&&audio.duration>0?Math.round(audio.currentTime/audio.duration*1000):0});listen(audio,'error',()=>status('Unable to load audio. Please check the MP3 URL.'));
    listen(seek,'input',()=>{if(Number.isFinite(audio.duration)&&audio.duration>0)audio.currentTime=audio.duration*seek.value/1000});listen(root.querySelector('[data-ao-volume]'),'input',e=>audio.volume=Number(e.target.value));listen(modeButton,'click',()=>{audio.loop=!audio.loop;syncPlaybackMode()});
    listen(root.querySelector('[data-ao-timer]'),'click',()=>{
      const values=[0,15,30,60];
      timerMinutes=values[(values.indexOf(timerMinutes)+1)%values.length];
      clearTimeout(endTimer);endTimer=null;
      if(timerMinutes)endTimer=setTimeout(()=>{
        pause();timerMinutes=0;endTimer=null;
        timerText.textContent='Sleep timer';status('Sleep timer finished.');
      },timerMinutes*60000);
      timerText.textContent=timerMinutes?'Stop in '+timerMinutes+' min':'Sleep timer';
    });
    listen(root.querySelector('[data-ao-jumplist]'),'click',()=>root.querySelector('.aoovoo-nature__playlist').scrollIntoView({behavior:'smooth',block:'start'}));
    let query=new URLSearchParams(window.location.search).get('scent')||root.dataset.defaultScent||'';let match=tracks.find(t=>t.dataset.key===query.toLowerCase())||tracks[0];choose(match,false);
    const scrollList=root.querySelector('.aoovoo-nature__tracks');
    const scrollRail=root.querySelector('[data-ao-scroll-rail]');
    const scrollThumb=root.querySelector('[data-ao-scroll-thumb]');
    function syncScrollbar(){
      const overflow=scrollList.scrollHeight-scrollList.clientHeight;
      scrollRail.hidden=overflow<=1;
      if(overflow<=1)return;
      const height=scrollRail.clientHeight;
      const thumb=Math.min(height,Math.max(28,height*scrollList.clientHeight/scrollList.scrollHeight));
      scrollThumb.style.height=thumb+'px';
      scrollThumb.style.transform='translateY('+((height-thumb)*scrollList.scrollTop/overflow)+'px)';
    }
    listen(scrollList,'scroll',syncScrollbar);
    listen(window,'resize',syncScrollbar);
    const scrollObserver=typeof ResizeObserver!=='undefined'?new ResizeObserver(syncScrollbar):null;
    if(scrollObserver){scrollObserver.observe(scrollList);tracks.forEach(track=>scrollObserver.observe(track))}
    let drag=null;
    listen(scrollRail,'pointerdown',event=>{
      if(event.button!==0)return;
      event.preventDefault();
      const rect=scrollRail.getBoundingClientRect();
      const thumbHeight=scrollThumb.offsetHeight;
      const travel=rect.height-thumbHeight;
      if(travel<=0)return;
      if(event.target!==scrollThumb){
        const ratio=Math.max(0,Math.min(1,(event.clientY-rect.top-thumbHeight/2)/travel));
        scrollList.scrollTop=ratio*(scrollList.scrollHeight-scrollList.clientHeight);
      }
      drag={id:event.pointerId,y:event.clientY,top:scrollList.scrollTop};
      scrollRail.setPointerCapture(event.pointerId);syncScrollbar();
    });
    listen(scrollRail,'pointermove',event=>{
      if(!drag||drag.id!==event.pointerId)return;
      const travel=scrollRail.clientHeight-scrollThumb.offsetHeight;
      if(travel>0)scrollList.scrollTop=drag.top+(event.clientY-drag.y)*(scrollList.scrollHeight-scrollList.clientHeight)/travel;
    });
    const stopDrag=()=>{drag=null};
    listen(scrollRail,'pointerup',stopDrag);
    listen(scrollRail,'pointercancel',stopDrag);
    listen(scrollRail,'lostpointercapture',stopDrag);
    syncScrollbar();
    function destroy(){
      if(destroyed)return;
      destroyed=true;requestId++;
      controller.abort();clearTimeout(endTimer);
      if(scrollObserver)scrollObserver.disconnect();
      audio.pause();audio.removeAttribute('src');audio.load();
      delete root.dataset.aoReady;
    }
    listen(root,'aoovoo:destroy',destroy);
    listen(document,'shopify:section:unload',event=>{
      if(event.target===root||event.target.contains(root))destroy();
    });
  }
  function boot(){document.querySelectorAll('[data-aoovoo-section]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  if(!window.aoovooNatureBootBound){
    document.addEventListener('shopify:section:load',boot);
    window.aoovooNatureBootBound=true;
  }
})();
